import { faGlobe } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ICorporationResponse } from '@kcftech/prometheustypescriptapiclient';
import { AuthorizedImage } from 'components/image/AuthorizedImage';
import { MenuLink } from 'styles/theme_styles/button';

export function CorporationLogoButton({
    url,
    selectedCorporation,
}: {
    url: string;
    selectedCorporation: ICorporationResponse;
}) {
    return (
        <MenuLink
            tabIndex={0}
            $padding="1rem"
            title="Corporation Overview"
            aria-label="Corporation Overview"
            to={url}
        >
            <AuthorizedImage
                src={selectedCorporation.IconUrl}
                aria-label={`Logo for ${selectedCorporation.Name}`}
                alt={`Logo for ${selectedCorporation.Name}`}
                className="corporation-logo"
                fallback={
                    <FontAwesomeIcon className="f-18 cursor-pointer" icon={faGlobe} />
                }
            />
        </MenuLink>
    );
}
